import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "./AxiosInstance";

const initialState = {
  posts: [],
  status: "idle",
  error: null,
};

export const fetchBankMaster = createAsyncThunk("posts/fetchPosts", async ({ url, FormDataDynamic }) => {
  try {
    const formData = new FormData();
    Object.keys(FormDataDynamic).forEach((key) => {
      formData.append(key, FormDataDynamic[key]);
    });

    const response = await axiosInstance.post(url, formData, {
      headers: {
        Accept: "*/*",
      },
    });

    return response && response.data;
  } catch (error) {
    console.error("Error fetching posts:", error);
    throw error;
  }
});

const getBankMasterSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBankMaster.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchBankMaster.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.posts = action.payload;
      })
      .addCase(fetchBankMaster.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default getBankMasterSlice.reducer;